module.exports = __webpack_public_path__ + "img/plus-circle.da5b7948.svg";